<app-page-stepper
    [verticalSteps]="false"
    [submitVisible]="false"
    (stepChange)="onStepChange($event)"
    (tryNext)="onTryNext()">
    <app-stepper [canContinue]="canContinue()">
        <ng-template #title>
            {{ "lineSetter.toolRequest.stepper.selectLine" | translate }}
        </ng-template>
        <ng-template #content
                     let-step="step">
            <div class="ls-tool-request">
                <h5>{{ "lineSetter.toolRequest.pages.selectManufacturingLine" | translate }}</h5>
                <form [formGroup]="toolRequestForm">
                    <div class="ls-request-main-data">
                        <div class="request-input-container">
                            <label [ngClass]="{'error': !selectedLine && firstNextTried}"
                                   for="manufacturing-line">
                                {{ 'lineSetter.toolRequest.stepper.manufacturingLine' | translate }}
                            </label>
                            <app-dropdown-autocomplete id="manufacturing-line"
                                                       [items]="lines"
                                                       [formControl]="toolRequestForm.controls['line']"
                                                       valueField="id"
                                                       displayField="name"
                                                       [emptyText]="'lineSetter.toolRequest.pages.searchManufacturingLine' | translate"
                                                       (selectItem)="onLineSelected($event)">
                            </app-dropdown-autocomplete>
                        </div>
                        <div class="request-input-container" *ngIf="selectedLine && selectedLine.isSPI"
                             [ngClass]="{'disabled': noInsertionCycles}">
                            <label [ngClass]="{'error': !selectedInsertionCycle && firstNextTried}"
                                   for="insertion-cycles">
                                {{ "lineSetter.toolRequest.stepper.insertionCycle" | translate }}
                            </label>
                            <app-dropdown-autocomplete id="insertion-cycles"
                                                       [items]="insertionCycles"
                                                       [formControl]="toolRequestForm.controls['insertionCycle']"
                                                       valueField="id"
                                                       displayField="name"
                                                       [emptyText]="'lineSetter.toolRequest.pages.searchInsertionCycle' | translate"
                                                       (selectItem)="onInsertionCycleSelect($event)">
                            </app-dropdown-autocomplete>
                        </div>
                    </div>
                </form>
            </div>

        </ng-template>
    </app-stepper>
    <app-stepper [canContinue]="selectedTools.length > 0">
        <ng-template #title>{{ "lineSetter.toolRequest.stepper.selectTools" | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <div class="tool-select-step">
                <div class="header">
                    <h2>{{ 'lineSetter.toolRequest.table.title' | translate }}</h2>
                    <app-display-label
                        [inlineLabel]="false"
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.manufacturingLine' | translate}}"
                        [value]="selectedLine?.name">
                    </app-display-label>
                    <app-display-label
                        [inlineLabel]="false"
                        labelClass="false"
                        label="{{'lineSetter.toolRequest.stepper.insertionCycle' | translate}}"
                        [value]="selectedInsertionCycle?.name">
                    </app-display-label>
                    <app-icon class="expand" library="material"
                              variant="{{this.allExpanded ? 'keyboard_arrow_up': 'keyboard_arrow_down' }}"
                              (click)="toggleExpanded()"></app-icon>
                    <app-icon class="toggle" library="material" variant="filter_list"
                              (click)="toggleFilters()"></app-icon>
                </div>
                <app-tool-request-table class="body"
                                        [toolsGrouped]="toolsGrouped"
                                        [selectedTools]="selectedTools"
                                        [isLoading]="isLoadingTools"
                                        [tableConfig]="tableConfig"
                                        [showFilters]="showFilters"
                                        [showGroupFilters]="showFilters"
                                        [isFilterExpanded]="showFilters"
                                        [showGroupers]="false"
                                        [isMaterial]="false"
                                        [hasTitle]="false"
                                        [allExpanded]="allExpanded"
                                        (sortChange)="onSortChange($event)"
                                        (filterChange)="onFilterChange($event)"
                                        (filterGroupChange)="onFilterGroupChange($event)"
                                        (groupChange)="onGroupChange($event)"
                                        (pageChange)="onPageChange($event)"
                                        [selectedLine]="selectedLine"
                                        (onToolClicked)="onToolClicked($event)">
                </app-tool-request-table>
            </div>
        </ng-template>
    </app-stepper>
    <app-stepper>
        <ng-template #title>Confirm</ng-template>
        <ng-template #content>
            <div class="tool-confirm-step">
                <div class="header">
                    <h2>{{ 'lineSetter.toolRequest.stepper.confirmTools' | translate }}</h2>
                    <app-display-label
                        [inlineLabel]="false"
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.manufacturingLine' | translate}}"
                        [value]="selectedLine?.name">
                    </app-display-label>
                    <app-display-label
                        [inlineLabel]="false"
                        labelClass="compact"
                        label="{{'lineSetter.toolRequest.stepper.insertionCycle' | translate}}"
                        [value]="selectedInsertionCycle?.name">
                    </app-display-label>
                </div>
                <div class="body">
                    <div class="row tools-to-order" *ngIf="currentStep === 3">
                        <ng-container *ngIf="!isLoadingTools">
                            <div class="tool-at-line">
                                <app-tool-scan-tree *ngIf="toolsToSwitch.length > 0"
                                                    [isMaterial]="false"
                                                    labelText="{{'lineSetter.toolRequest.pages.scanTreeToolAtline' | translate}}"
                                                    [items]="toolsToSwitch">
                                </app-tool-scan-tree>
                            </div>
                            <app-tool-scan-tree *ngIf="toolsFromAtom.length > 0"
                                                [isMaterial]="false"
                                                labelText="{{'lineSetter.toolRequest.pages.scanTreeLabel' | translate}}"
                                                [items]="toolsFromAtom">
                            </app-tool-scan-tree>
                        </ng-container>
                        <app-loading-spinner *ngIf="isLoadingTools"></app-loading-spinner>
                    </div>
                </div>
                <div class="footer">
                    <div *ngIf="toolsToSwitch.length > 0" class="line-setter-consent">
                        <app-input-switch (inputChange)="onConsent($event)"></app-input-switch>
                        {{ 'lineSetter.toolRequest.messages.consent' | translate }}
                    </div>
                    <div class="buttons-container-tool-request">
                        <app-icon-button
                            class="left"
                            [responsive]="true"
                            text="{{'lineSetter.toolRequest.pages.buttonOrder' | translate }}"
                            [disabled]="!hasGiveConsent"
                            (click)="onOrder(false)">
                        </app-icon-button>
                        <app-icon-button
                            class="right"
                            variant="fa-exclamation-circle"
                            text="{{ 'lineSetter.toolRequest.pages.buttonOrderPriority' | translate }}"
                            [responsive]="true"
                            [disabled]="!hasGiveConsent"
                            (click)="onOrder(true)">
                        </app-icon-button>
                    </div>
                </div>
            </div>
        </ng-template>
    </app-stepper>
</app-page-stepper>
<app-confirmation-modal (confirmEvent)="onConfirmOrder($event)"
                        #successModal
                        title="{{'lineSetter.toolRequest.pages.popupTitle' | translate}}"
                        question="{{'lineSetter.toolRequest.pages.popupQuestion' | translate}}"
                        message="{{confirmationPopupMessage}}"
                        displayReasonLabel="{{'lineSetter.toolRequest.messages.priorityMessageLabel' | translate}}"
                        displayReasonPlaceholder="{{'lineSetter.toolRequest.messages.priorityMessagePlaceholder' | translate}}"
                        [isConfirmationInProgress]="isConfirmationInProgress"
                        [confirmOnlyMode]="!orderWithPriority"
                        [confirmWithReason]="orderWithPriority">
</app-confirmation-modal>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [question]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [isError]="isError"
                        [showConfirmButton]="false ">
</app-confirmation-modal>
<app-logout-modal
    title="{{ 'lineSetter.toolRequest.pages.logoutModal.title' | translate }}"
    infoMessage="{{ 'lineSetter.toolRequest.pages.logoutModal.infoMessage' | translate }}"
    [timer]="badgeLogoutCountdownSeconds">
</app-logout-modal>
